import strings from "../app.strings.js";
import { store } from "../store";

export default {
  data: () => ({
    alert: true,
    alertText: false,
    menu: [],
    firstLoadServiceRequest: true,
    loadingFromBackendModal: false
  }),
  methods: {
    closeFormAlert() {
      this.alertText = false
    },
    handleAlertText() {
	let alertText = store.state.main.alertText;
	store.commit("SET_ALERT_TEXT", false);
	return alertText;
    },
    handleAlertText2(message, type = "success") {
	store.commit("SET_ALERT_TEXT", { type, message });
	let alertText = store.state.main.alertText;
	store.commit("SET_ALERT_TEXT", false);
	return alertText;
    },
    defaultHandlerError(e) {
	this.hideLoadingAskWait();
	this.hideLoadingIndicator();
	let options = e.response.data;

	if (e.response.status == 404 && !options.title && !options.message)
	    options = strings.default404Text;

	this.setErrorModal(options);
	return;
    },

    handlerErrors(e) {
	let message = "";
	let options = {};
	if (e.data) {
	    options = e.data;
	} else if (e.response) {
	    options = e.response.data;
	}

	if (options !== undefined && options !== {} && options !== null) {
	    console.error(options);
	    this.hideLoadingAskWait();
	    this.hideLoadingIndicator();

	    if (e.response.status == 404 && !options.title && !options.message) {
		options = strings.default404Text;
		message = strings.default404Text.message;
	    } else
		message = options.message;
	    this.setErrorModal(options);
	} else {
	    let options = {
		title: "Erro",
		message: strings.requestError.message
	    };
	    message = strings.requestError.message;
	    this.setErrorModal(options);
	    this.hideLoadingAskWait();
	    this.hideLoadingIndicator();
	}

	return message;
    },
    setErrorModal(options) {
	if (!options.title)
	    options.title = "Erro Indefinido";

	if (!options.message)
	    options.message = "Por favor, contate o administrador";

	if (!options.details)
	    options.details = "Sem detalhes";

	if (!options.callback)
	    options.callback = this.hideErrorModal;

	this.setErrorModalMessages(options);
	this.showErrorModal();
    },
    setErrorModalMessages(options) {
	let payload = options;
	store.commit("SET_ERROR_MODAL", payload);
	return;
    },
    showErrorModal() {
	store.commit("SET_ERROR_MODAL_FLAG", true);
    },
    hideErrorModal() {
	store.commit("SET_ERROR_MODAL_FLAG", false);
    },
    showLoadingIndicator() {
	store.commit("SET_LOADING_INDICATOR_FLAG", true);
    },
    hideLoadingIndicator() {
	store.commit("SET_LOADING_INDICATOR_FLAG", false);
    },
    showLoadingAskWait() {
	store.commit("SET_LOADING_ASK_WAIT_FLAG", true);
    },
    hideLoadingAskWait() {
	store.commit("SET_LOADING_ASK_WAIT_FLAG", false);
    },
    setHiddeDrawer() {
	store.commit("SET_DRAWER", false);
    },
    setShowDrawer() {
	store.commit("SET_DRAWER", true);
    },
    getDrawer() {
	return store.commit("GET_DRAWER");
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/ViewMixin.js